import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import MessageHub from '../../../../core/signalr/SignalrMessageHub';
import { ChanelConfig } from '../../../../configs/GlobalConfig';
import withMarketPreOpen from '../../../common/market-pre-open/withMarketPreOpen';
import Content from './Content';
import { REDUCER_NAME, setIndexData } from './reducer';

class Contribution extends React.Component {
  componentDidMount() {
    MessageHub.subscribe(ChanelConfig.IndexChannel, this.onReceiveIndex);
  }

  componentWillUnmount() {
    MessageHub.unsubscribe(ChanelConfig.IndexChannel, this.onReceiveIndex);
  }

  onReceiveIndex = data => {
    const { comGroupCode, setIndexData } = this.props;
    const index = data.find(item => item.comGroupCode === comGroupCode);
    if (index) {
      setIndexData(index);
    }
  };

  render() {
    return (
      <div className={'d-flex flex-column flex-fill'}>
        <Content />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  comGroupCode: state[REDUCER_NAME].comGroupCode,
});

const mapDispatchToProps = {
  setIndexData,
};

export default compose(
  //withMarketPreOpen('flex-fill'), -- hidden preopen market clock
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(Contribution);
